import { SimpleTableHeadColumn } from '../configuration-files/types';

export const headCells: SimpleTableHeadColumn[] = [
  {
    id: 'file-name',
    label: 'File Name',
    accessor: 'fileName',
  },
  {
    id: 'uploadDate',
    label: 'Upload Date #',
    accessor: 'createdTime',
  },
  {
    id: 'userId',
    label: 'User ID',
    accessor: 'createdBy',
  },
];
